export enum EHistoryIsEmpty {
	NotEmpty = 'NotEmpty',
	Empty = 'Empty',
}

export const HISTORY_IS_EMPTY_LABEL_MAP: Record<EHistoryIsEmpty, string> = {
	[EHistoryIsEmpty.NotEmpty]: `history_is_empty.${EHistoryIsEmpty.NotEmpty}`,
	[EHistoryIsEmpty.Empty]: `history_is_empty.${EHistoryIsEmpty.Empty}`
}